import { base64URLEncode, createCodeVerifier, getEncodedVerifierKey, hashed, sha256 } from './authenticationHelper';

const authorize = async ({
  redirectUri,
  provider,
  authorizationEndpoint,
  clientId,
  scopes,
  clientSecret,
  storage = sessionStorage,
}) => {
  const encodedVerifier = base64URLEncode(createCodeVerifier());
  const code_challenge = base64URLEncode(sha256(encodedVerifier));
  storage.setItem(
    getEncodedVerifierKey(clientId),
    JSON.stringify({
      encodedVerifier,
      redirectUri,
    }),
  );
  const query = {
    client_id: clientId,
    client_secret: clientSecret,
    response_type: 'code',
    redirect_uri: redirectUri,
    code_challenge: code_challenge,
    code_challenge_method: 'S256',
    scope: scopes && scopes.length > 0 ? scopes.join(' ') : undefined,
  };
  const url = `${provider}${authorizationEndpoint}?${hashed(query)}`;
  window.location.replace(url);
};
export default authorize;
